import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';



class SearchCard extends React.Component {
    _isMounted = false;
    state = {
        transactions:[],
        cardNumber:'',
        cardPin:'',
        sku:'',
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
    }


    async loadData() {
        if (this._isMounted) {
            this.setState({
                alert: 0,
                alertMessage: ''
            });
        }

        let bodyData = {
            cardNumber: this.state.cardNumber,
            pin: this.state.cardPin,
            gc:'QwikCilver',
            sku:this.state.sku,
            refno:this.state.cardNumber
        };
        //check-card-balance // check-card-transaction
            await RestServices.GlobalPost(
                localStorage.getItem('FirebaseToken'),
                bodyData,
                'gift-card/check-card-balance'
            )
                .then((response) => response.json())
                .then((responseData) => {
                    
                })

                await RestServices.GlobalPost(
                    localStorage.getItem('FirebaseToken'),
                    bodyData,
                    'gift-card/check-card-transaction'
                )
                    .then((response) => response.json())
                    .then((responseData) => {
                        
                    })
    }

    

    submitSearch = () => {
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            cardNumber: '',
            cardPin: '',
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    

    onChangeValues = (event) => {
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };
    render() {
        
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Gift Card Transactions
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    
                                    <Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Card SKU"
                                        type="text"
                                        name="sku"
                                        value={this.state.sku}
                                        onChange={this.onChangeValues}
                                    />
                                    <Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Card Number"
                                        type="text"
                                        name="cardNumber"
                                        value={this.state.cardNumber}
                                        onChange={this.onChangeValues}
                                    />
                                    <Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Card Pin"
                                        type="text"
                                        name="cardPin"
                                        value={this.state.cardPin}
                                        onChange={this.onChangeValues}
                                    />
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <MaterialTable
                            title="Transactions"
                            columns={[
                                {
                                    title: 'Slug Name',
                                    field: 'name',
                                    render: (row) => (
                                        <div>
                                            {row.name}
                                        </div>
                                    )
                                },
                                {
                                    title: 'Slug',
                                    field: 'slug',
                                    render: (row) => (
                                        <div>
                                            {row.slug}
                                        </div>
                                    )
                                },
                            ]}
                            data={this.state.transactions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        
                   
                
            </Container>
        );
    }
}

export default SearchCard;
